var _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02602 9.38545C3.02602 7.8068 4.6971 6.8018 6.00956 7.59112L25.6193 19.3845C26.9119 20.1619 26.8871 22.1028 25.5744 22.8923L5.96471 34.6857C4.65202 35.4751 3.02602 34.5271 3.02602 32.9723L3.02602 9.38545Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.90405,
    y1: 51.7646,
    x2: 49.6423,
    y2: 51.7647,
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.4236,
    y1: 37.6055,
    x2: 49.6424,
    y2: 37.6055,
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 37.9429,
    y1: 23.4463,
    x2: 49.6422,
    y2: 23.4463,
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistIcon);
export default __webpack_public_path__ + "static/media/playlist-icon.2fc7a9ba31f5cb9e34bdd3ab4335640b.svg";
export { ForwardRef as ReactComponent };